import React, { Fragment } from "react";
import {
  getActivities,
  bookingAPICall,
  PeopleInputs,
  Calendar,
  searchAvailableSlots,
  SelecOptions,
  createHold,
  PeopleTotalCosts,
  resetCurrentGroupSize,
  getTotalCosts,
} from "./Index";
import {
  ApplePay,
  CreditCard,
  GiftCard,
  GooglePay,
  PaymentForm as SquarePaymentForm,
} from "react-square-web-payments-sdk";
import OutlinedInput from "@mui/material/OutlinedInput";
import FormControl from "@mui/material/FormControl";
import { TextField, MenuItem, Select, InputLabel } from "@material-ui/core";
import Modal from "../assets/Modal";

const development =
  !process.env.NODE_ENV || process.env.NODE_ENV === "development";
const appId = development
  ? "sandbox-sq0idb-X_YG4ZeQm5yeVXAaEjH9Aw"
  : "sq0idp-Zt66ubgBvwkuijlDQBQGpQ";
const locationId = development ? "1D1W0QXPXSXTF" : "EENN0H8C8XBVN";

const CREDIT_CARD = "Credit Card";
const GIFT_CARD = "Gift Card";
const APPLY_PAY = "Apple Pay";
const GOOGLE_WALLET = "Google Wallet";

const AllowedPaymentOptions = [CREDIT_CARD, GIFT_CARD, GOOGLE_WALLET];

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const PaymentOptionProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

class Booking extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showForms: false,
      formType: null,
      activities: [],
      currentProductInfo: null,
      currentPricing: null,
      people: {},
      date: {
        year: new Date().getFullYear(),
        month: new Date().getMonth() + 1,
      },
      calendar: null,
      selectedSlot: null,
      customerInfo: {},
      cancelationPolicyAccepted: false,
      orderTotal: 0.0,
      remainingBalance: 0.0,
      incompletePayment: false,
      orderId: null,
      bookingId: null,
      paymentType: "Credit Card",
      error: null,
    };

    this.clearError = this.clearError.bind(this);
    this.setError = this.setError.bind(this);
    this.setHoldCreated = this.setHoldCreated.bind(this);
    this.handlePaymentOptionChange = this.handlePaymentOptionChange.bind(this);
  }

  componentDidMount() {
    bookingAPICall("GET", "/booking", null, (data) => {
      console.log(data);
      this.setState({
        contentType: "calendar",
        activities: data.activities,
      });
    });
  }

  componentWillUnmount() {
    if (this.holdTimer) {
      clearInterval(this.holdTimer);
    }
  }

  clearError() {
    this.setState({ error: null });
  }

  setError(errorMessage) {
    this.setState({ error: errorMessage });
  }

  calculateTimeLeft(expirestAt) {
    const difference = +expirestAt - +new Date();
    let timeLeft = {};
    if (difference > 0) {
      timeLeft = {
          days: Math.floor(difference / (1000 * 60 * 60 * 24)),
          hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
          minutes: Math.floor((difference / 1000 / 60) % 60),
          seconds: Math.floor((difference / 1000) % 60)
      };
    }
    return timeLeft;
  }

  setHoldCreated(hold_response) {
    console.log(hold_response);
    const bookingResponse = hold_response && hold_response[0] ? hold_response[0] : null;
    if (!bookingResponse || !bookingResponse.hold) {
      this.setError("Unable to process booking hold.");
      return;
    }

    const parsedAmount = parseFloat(
      String(bookingResponse.amount || "0").replace(/[^0-9.-]/g, "")
    );
    const amountFromHold =
      bookingResponse.hold &&
      bookingResponse.hold.totalPayable &&
      bookingResponse.hold.totalPayable.amount != null
        ? Number(bookingResponse.hold.totalPayable.amount)
        : null;
    const orderTotalCents =
      bookingResponse.amountCents != null
        ? Number(bookingResponse.amountCents)
        : Number.isFinite(parsedAmount)
        ? Math.round(parsedAmount * 100)
        : Math.round(Number(amountFromHold || 0) * 100);
    const isFreeBooking =
      bookingResponse.freeBooking === true || orderTotalCents <= 0;

    if (isFreeBooking) {
      window.location.replace(
        "/booking/confirmation?booking=" + bookingResponse.bookingId
      );
      return;
    }

    const timestamp = Date.parse(bookingResponse.hold.expiration);
    const expirestAt = new Date(timestamp);
    if (this.holdTimer) {
      clearInterval(this.holdTimer);
    }
    this.holdTimer = setInterval(() => {
      const timeLeft = this.calculateTimeLeft(expirestAt);
      if (+expirestAt - +new Date() <= 0) {
        clearInterval(this.holdTimer);
        this.holdTimer = null;
        this.setError("Your hold has expired. Please start your booking again.");
        window.location.replace("/book/now");
        return;
      }
      this.setState({ holdTimeRemaining: timeLeft });
    }, 1000);
    this.setState({
      formType: "process-payment",
      orderTotal: orderTotalCents,
      remainingBalance: orderTotalCents,
      bookingId: bookingResponse.bookingId,
      expiresAt: expirestAt.toLocaleTimeString('en-US', {
    hour: 'numeric',
    minute: 'numeric',
    hour12: true,
  }),
    });
  }

   handlePaymentOptionChange(event) {
    const {
      target: { value },
    } = event;
    this.setState({
      paymentType: value,
    });
  }

  async createPayment(token, remainingBalance, paymentType) {
    const body = JSON.stringify({
      paymentSourceId: token,
      remainingBalance: remainingBalance,
      paymentType: paymentType,
      bookingId: this.state.bookingId,
    });

    const paymentResponse = await fetch("/book/payment", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body,
    })
      .then((response) => response.json())
      .then((data) => {
        console.log("Payment Results: ", data);
        if (data.error == null) {
          return data;
        } else {
          console.log("Payment Error:");
          console.log(data.error);
          return data;
        }
      });
    return paymentResponse;
  }

  render() {
    return (
      <div className="container">
        <Modal message={this.state.error} onClose={this.clearError} />
        <div
          id="booking-form-overlay"
          style={{
            width: this.state.showForms ? "100%" : "0",
          }}
        >
          <div className="form-container">
            <div
              id="booking-form"
              className={`booking-form-container booking-form-container-${
                this.state.formType == "booking-form" ? "expanded" : "collapsed"
              }`}
            >
              <div className="page-title">Confirm your booking</div>
              <div className="booking-form-content">
                <h4 id="booking-form-header"></h4>
                <h5 id="booking-form-date"></h5>
                <h5 id="booking-form-time-range"></h5>
                <div id="booking-form-event-description"></div>
                <p>Please confirm attendees:</p>
                <div id="booking-form-people" className="guest-type">
                  {this.state.currentProductInfo != null ? (
                    <PeopleInputs
                      section="booking-form"
                      peopleLimits={this.state.currentProductInfo.people_limits}
                      currentValues={this.state.people}
                      callback={(newPeopleCount) => {
                        console.log(newPeopleCount.id);
                        console.log(newPeopleCount.qty);
                        this.setState({
                          people: {
                            ...this.state.people,
                            [newPeopleCount.id]: newPeopleCount.qty,
                          },
                        });
                      }}
                    />
                  ) : (
                    ""
                  )}
                </div>
                <div className="total-price">
                  <PeopleTotalCosts
                    productInfo={this.state.currentProductInfo}
                    people={this.state.people}
                  />
                </div>
                <div id="booking-form-options" className="guest-type"></div>
                <div className="booking-form-buttons">
                  <div
                    className="purple-button"
                    onClick={() =>
                      this.setState({
                        showForms: false,
                        formType: null,
                      })
                    }
                  >
                    Cancel
                  </div>
                  <div
                    className="purple-button"
                    onClick={() =>
                      this.setState({ formType: "customer-info-form" })
                    }
                  >
                    Next
                  </div>
                </div>
              </div>
            </div>
            <div
              id="customer-info-form"
              className={`booking-form-container booking-form-container-${
                this.state.formType == "customer-info-form"
                  ? "expanded"
                  : "collapsed"
              }`}
            >
              <div className="page-title">Your information</div>
              <div className="booking-form-content">
                <p>Please enter your contact information:</p>
                <input
                  type="text"
                  id="first_name"
                  placeholder="First Name"
                  onChange={(e) =>
                    this.setState({
                      customerInfo: {
                        ...this.state.customerInfo,
                        firstName: e.target.value,
                      },
                    })
                  }
                />
                <input
                  type="text"
                  id="last_name"
                  placeholder="Last Name"
                  onChange={(e) =>
                    this.setState({
                      customerInfo: {
                        ...this.state.customerInfo,
                        lastName: e.target.value,
                      },
                    })
                  }
                />
                <input
                  type="text"
                  id="email"
                  placeholder="johndoe@email.com"
                  onChange={(e) =>
                    this.setState({
                      customerInfo: {
                        ...this.state.customerInfo,
                        email: e.target.value,
                      },
                    })
                  }
                />
                <input
                  type="text"
                  id="phone"
                  placeholder="###-###-####"
                  onChange={(e) =>
                    this.setState({
                      customerInfo: {
                        ...this.state.customerInfo,
                        phone: e.target.value,
                      },
                    })
                  }
                />
                <div className="booking-form-buttons">
                  <div
                    className="purple-button"
                    onClick={() => this.setState({ formType: "booking-form" })}
                  >
                    Back
                  </div>
                  <div
                    className="purple-button"
                    onClick={() => {
                      if (
                        this.state.customerInfo.firstName == null ||
                        this.state.customerInfo.lastName == null ||
                        this.state.customerInfo.email == null ||
                        this.state.customerInfo.phone == null
                      ) {
                        alert("Please fill out all contact information!");
                        return;
                      }
                      this.setState({ formType: "cancelation-policy-form" });
                    }}
                  >
                    Next
                  </div>
                </div>
              </div>
            </div>
            <div
              id="cancelation-policy-form"
              className={`booking-form-container booking-form-container-${
                this.state.formType == "cancelation-policy-form"
                  ? "expanded"
                  : "collapsed"
              }`}
            >
              <div className="page-title">Cancellation Policy</div>
              <div className="booking-form-content">
                <p>
                  Cancellations can be made up to 7 days before the visit, after
                  that, no refunds accepted.
                </p>
                <p>
                  <strong>Weather Cancellation Policy:</strong>
                  In the case of extreme weather conditions (including but not
                  limited to snow, very cold temperatures, thunderstorms, and
                  heavy rain) Dakota Ridge Farm may cancel the field trip and
                  will notify you via phone or email one day prior. If the trip
                  is cancelled due to inclement weather, you can reschedule
                  within 1 year or the deposit will be returned in full.
                </p>
                <p>
                  <strong>Rescheduling:</strong> You can reschedule your visit
                  and add or remove guests up to 48 hours in advance of your
                  farm visit.
                </p>
                <p>
                  All refunds will be processed within 10 business days. If you
                  do not show for your tour or trek, no refund will be given.
                </p>
                <p>
                  <strong>
                    Please download, print and sign the waiver using the link
                    below for each individual or each Family in your party and
                    bring them with you the day of your visit. If you are unable
                    to print out, we will have blank forms for you to sign when
                    you arrive.
                  </strong>
                </p>
                <p>
                  <a
                    href="/documents/Assumption of Risks Dakota Ridge Farm LLC.pdf"
                    target="_blank"
                  >
                    Click here to Download the Waiver
                  </a>
                </p>
                <div className="policy-acceptance">
                  <label htmlFor="cancelation-policy-accepted">
                    <input
                      id="cancelation-policy-accepted"
                      type="checkbox"
                      checked={this.state.cancelationPolicyAccepted}
                      onChange={(e) => {
                        this.setState({
                          cancelationPolicyAccepted: e.target.checked,
                        });
                      }}
                    />
                    I Accept
                  </label>
                </div>
                <div className="booking-form-buttons">
                  <div
                    className="purple-button"
                    onClick={() =>
                      this.setState({ formType: "customer-info-form" })
                    }
                  >
                    Back
                  </div>
                  <div
                    id="book-button"
                    className={`purple-button ${
                      this.state.cancelationPolicyAccepted
                        ? "enabled"
                        : "disabled"
                    }`}
                    onClick={() => {
                      if (!this.state.cancelationPolicyAccepted) {
                        alert("Please Accept the Cancellation Policy!");
                        return;
                      }
                      this.setState({ formType: "giftcard-info-notice" });
                    }}
                  >
                    Next
                  </div>
                </div>
              </div>
            </div>
            <div
              id="giftcard-info-notice"
              className={`booking-form-container booking-form-container-${
                this.state.formType == "giftcard-info-notice"
                  ? "expanded"
                  : "collapsed"
              }`}
            >
              <div className="page-title">Gift Cards</div>
              <div className="booking-form-content">
                {getTotalCosts(
                  this.state.currentProductInfo,
                  this.state.people
                ) > 0.0 ? (
                  <p>
                    If you have a gift card you would like to use to book, enter
                    the Gift Card Information <strong>FIRST</strong> on the payment screen. If your total is more than the gift card balance, you will be prompted to pay the remaining balance using a Debit/Credit Card.
                  </p>
                ) : (
                  <p>
                    It looks like you booked a <strong>FREE</strong> event!
                    Please press <strong>'Book'</strong> to set your
                    reservation.
                  </p>
                )}
                <div className="booking-form-buttons">
                  <div
                    className="purple-button"
                    onClick={() =>
                      this.setState({ formType: "cancelation-policy-form" })
                    }
                  >
                    Back
                  </div>
                  <div
                    id="book-button"
                    className={`purple-button ${
                      this.state.cancelationPolicyAccepted
                        ? "enabled"
                        : "disabled"
                    }`}
                    onClick={() => {
                      if (!this.state.cancelationPolicyAccepted) {
                        alert("Please Accept the Cancellation Policy!");
                        return;
                      }
                      createHold(
                        this.state.currentProductInfo,
                        this.state.selectedSlot,
                        this.state.people,
                        this.state.customerInfo,
                        this.setHoldCreated,
                        this.setError
                      );
                    }}
                  >
                    Book
                  </div>
                </div>
              </div>
            </div>
            <div
              id="payment-modal"
              className={`booking-form-container booking-form-container-${
                this.state.formType == "process-payment"
                  ? "expanded"
                  : "collapsed"
              }`}
            >
              <div className="square-container">
                <p className="heading">
                    Holding your spot until {this.state.expiresAt} {this.state.holdTimeRemaining && this.state.holdTimeRemaining.minutes != null ? `(${this.state.holdTimeRemaining.minutes} minutes, ${this.state.holdTimeRemaining.seconds} seconds remaining)` : ""}
                  </p>
                {this.state.incompletePayment ? (
                  <p className="heading">
                    Remaining Amount: $
                    {(this.state.remainingBalance / 100.0).toFixed(2)}
                  </p>
                ) : (
                  <p className="heading">
                    Order Total: ${(this.state.orderTotal / 100.0).toFixed(2)}
                  </p>
                )}
                <p className="heading">
                  If you would like to use a gift card, please enter the gift
                  card information first.
                </p>
                <FormControl sx={{ m: 1, width: "100%", mt: 3 }}>
                  <p className="heading">Select payment Type</p>
                  <Select
                    disabled={this.state.incompletePayment}
                    value={this.state.paymentType}
                    onChange={this.handlePaymentOptionChange}
                    input={<OutlinedInput />}
                    MenuProps={PaymentOptionProps}
                    inputProps={{ id: "payment-select" }}
                  >
                    {AllowedPaymentOptions.map((name) => (
                      <MenuItem key={name} value={name}>
                        {name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                {this.state.isLoading ? (
                  <p>Processing Payment...</p>
                ) : (
                  <SquarePaymentForm
                    sandbox
                    applicationId={appId}
                    locationId={locationId}
                    cardTokenizeResponseReceived={async (
                      tokenResp,
                      verifiedBuyer
                    ) => {
                      if (tokenResp.status != "OK") {
                        console.error("Tokenization failed");
                        return;
                      }

                      this.setState({ isLoading: true });

                      var paymentResults = await this.createPayment(
                        tokenResp.token,
                        this.state.remainingBalance,
                        this.state.paymentType
                      );
                      console.log("Results Payment Results");
                      console.log(paymentResults);
                      this.setState({ isLoading: false });
                      if (paymentResults.error) {
                        console.error("Payment Failed");
                        this.setState({ error: paymentResults.msg[0].detail });
                        return;
                      }

                      if (paymentResults.success && paymentResults.booking_id) {
                        this.setState({
                          remainingBalance: 0.0,
                        });
                        window.location.replace(
                          "/booking/confirmation?booking=" +
                            paymentResults.booking_id
                        );
                      } else if (
                        paymentResults.remainingBalance != null &&
                        paymentResults.booking_id
                      ) {
                        this.setState({
                          bookingId: paymentResults.booking_id,
                          remainingBalance: paymentResults.remainingBalance,
                          incompletePayment: true,
                          paymentType: "Credit Card",
                          isLoading: false,
                        });
                      } else {
                        this.setState({
                          error: "Payment could not be processed.",
                        });
                      }
                    }}
                    createPaymentRequest={() => ({
                      countryCode: "US",
                      currencyCode: "USD",
                      total: {
                        amount: this.state.remainingBalance
                          ? (this.state.remainingBalance / 100.0).toFixed(2)
                          : "",
                        label: "Total",
                      },
                    })}
                  >
                    {this.state.paymentType == "Apple Pay" ? (
                      <>
                        <ApplePay />
                      </>
                    ) : (
                      <></>
                    )}
                    {this.state.paymentType == "Google Wallet" ? (
                      <>
                        <GooglePay />
                      </>
                    ) : (
                      <></>
                    )}
                    {this.state.paymentType == "Credit Card" ? (
                      <>
                        <CreditCard
                          buttonProps={{
                            css: {
                              backgroundColor: "#009cab",
                              fontSize: "14px",
                              color: "#fff",
                              "&:hover": {
                                backgroundColor: "#8e1cff",
                              },
                            },
                          }}
                        />
                      </>
                    ) : (
                      <></>
                    )}
                    {this.state.paymentType == "Gift Card" ? (
                      <>
                        <p className="heading">
                          Note: If the gift card does not cover the whole
                          amount, you be prompted to pay the remaining balance
                          with a credit card.
                        </p>
                        <GiftCard
                          buttonProps={{
                            css: {
                              backgroundColor: "#009cab",
                              fontSize: "14px",
                              color: "#fff",
                              "&:hover": {
                                backgroundColor: "#8e1cff",
                              },
                            },
                          }}
                        />
                      </>
                    ) : (
                      <></>
                    )}
                  </SquarePaymentForm>
                )}
              </div>
            </div>
          </div>
        </div>
        <div
          className="container"
          style={{
            display: this.state.contentType == "calendar" ? "block" : "none",
          }}
        >
          {/* <%= render "layouts/drf_theme/header", obj: @page %> */}
          <div className="calendar-body">
            <div className="page-title" htmlFor="activity_selector">
              Select the event type you would like to attend:
            </div>
            <div className="event-type-section">
              {getActivities(
                this.state.activities,
                this.state.currentProductInfo,
                (data) => {
                  console.log(data);
                  resetCurrentGroupSize();
                  this.setState({
                    currentProductInfo: data,
                    calendar: null,
                    selectedSlot: null,
                    people: {},
                    currentPricing: null,
                  });
                }
              )}
            </div>
            <div
              className="attendees-container"
              style={{
                display:
                  this.state.currentProductInfo != null ? "block" : "none",
              }}
            >
              <div className="page-title" htmlFor="activity_selector">
                How many will be attending in your group?
              </div>
              <div id="num-input-div" className="guest-type">
                {this.state.currentProductInfo != null ? (
                  <PeopleInputs
                    section="main_screen"
                    peopleLimits={this.state.currentProductInfo.people_limits}
                    currentValues={this.state.people}
                    callback={(newPeopleCount) => {
                      console.log(newPeopleCount.id);
                      console.log(newPeopleCount.qty);
                      this.setState({
                        people: {
                          ...this.state.people,
                          [newPeopleCount.id]: newPeopleCount.qty,
                        },
                      });
                    }}
                  />
                ) : (
                  ""
                )}
              </div>
            </div>
            <div
              className="date-container"
              style={{
                display:
                  this.state.currentProductInfo != null ? "block" : "none",
              }}
            >
              <div className="page-title">
                When do you want to book your visit?
              </div>
              <div className="date-selection-container">
                <label htmlFor="booking-date-month">Select Date:</label>
                <div className="date-selection">
                  <select
                    id="booking-date-month"
                    name="date[month]"
                    onChange={(e) => {
                      this.setState({
                        date: { ...this.state.date, month: e.target.value },
                      });
                    }}
                    value={this.state.date.month}
                  >
                    <option value="1">Jan</option>
                    <option value="2">Feb</option>
                    <option value="3">Mar</option>
                    <option value="4">Apr</option>
                    <option value="5">May</option>
                    <option value="6">Jun</option>
                    <option value="7">Jul</option>
                    <option value="8">Aug</option>
                    <option value="9">Sep</option>
                    <option value="10">Oct</option>
                    <option value="11">Nov</option>
                    <option value="12">Dec</option>
                  </select>
                  {" / "}
                  <select
                    name="booking-date-year"
                    id="booking-date-year"
                    onChange={(e) => {
                      this.setState({
                        date: { ...this.state.date, year: e.target.value },
                      });
                    }}
                  >
                    <SelecOptions />
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div className="view-calendar-button">
            <div
              className="purple-button"
              onClick={() =>
                searchAvailableSlots(
                  this.state.currentProductInfo,
                  this.state.people,
                  this.state.date.year + "-" + this.state.date.month + "-1",
                  (data) => {
                    console.log(data);
                    this.setState({ calendar: data.data });
                  }
                )
              }
            >
              Check Availability
            </div>
          </div>
          <div className="row">
            <Calendar
              calendar={this.state.calendar}
              onSlotClicked={(slotId) => {
                this.setState({
                  showForms: true,
                  formType: "booking-form",
                  selectedSlot: slotId,
                });
              }}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default Booking;
